const Customer360 = [
  {
    path: '/customer/customer-360',
    name: 'customer-360',
    component: () => import(/* webpackChunkName: "customer" */'./views/Customer360.vue'),
    meta: {
      requiresAuth: true,
      title: 'AlgoStack Analytics Customer 360',
      breadCrumbs: [
        {
          name: 'Customer 360',
          path: '/customer/customer-360',
        },
      ],
    },
    children: [],
  },
  {
    path: '/customer/customer-charts',
    name: 'customer-charts',
    component: () => import(/* webpackChunkName: "customer" */'./views/CustomerCharts.vue'),
    meta: {
      requiresAuth: true,
      title: 'AlgoStack Analytics Customer 360 Charts',
      breadCrumbs: [
        {
          name: 'Customer 360 Charts',
          path: '#',
        },
      ],
    },
    children: [],
  },
  {
    path: '/customer/customers/:id',
    name: 'customer-insight',
    component: () => import(/* webpackChunkName: "customer" */'./views/CustomerInformation.vue'),
    meta: {
      requiresAuth: true,
      title: 'AlgoStack Analytics Customer Information',
      breadCrumbs: [
        {
          name: 'Customer 360',
          path: '/customer/customer-360',
        },
        {
          name: 'Customer',
          path: '#',
        },
      ],
    },
  },
];

export default Customer360;
